export enum EChangeType {
  NEU = 'NEU',
  LOESCHUNG = 'LOESCHUNG',
  AKTUALISIERUNG = 'AKTUALISIERUNG',
  FASSUNGSAENDERUNG = 'FASSUNGSAENDERUNG'
}
